<template>
  <div class="applicant-grid">
    <applicant-grid-item
      v-for="(applicant, index) in applicants"
      :key="index"
      :applicant="applicant"
      :snsType="snsType"
      @change_flag="changeFlag"
      @change_ng="changeNg"
    ></applicant-grid-item>
    <div layout layout-align="space-between-center">
      <pagination
        flex="1"
        :total="options.total"
        :pagingNo="options.pagingNo"
        :limitCount="options.limitCount"
        @paging="onPaging"
      ></pagination>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapActions } from 'pinia'
import { defineComponent } from 'vue'

import ApplicantGridItem from '@/client/components/_atoms/applicant_grid_item'
import ApplicantName from '@/client/components/_atoms/applicant_name'
import Icon from '@/client/components/_atoms/basic_icon'
import Pagination from '@/client/components/_atoms/pagination'
import { useInstagramApplicantStore } from '@/client/store/useInstagramApplicantStore'

export default defineComponent({
  props: {
    applicants: Array,
    snsType: {
      type: String,
      default: 'instagram'
    },
    options: Object
  },
  components: {
    Pagination,
    ApplicantName,
    Icon,
    ApplicantGridItem
  },
  methods: {
    ...mapActions(useInstagramApplicantStore, ['fetchApplicants']),

    /**
     * フラグ変更処理
     * @param {{type: string, value: any}} payload
     */
    changeFlag(payload: { type: string; value: any }) {
      const newPayload = {}

      newPayload.applicantId = payload.value.applicantId
      switch (payload.type) {
        case 'candidate':
          newPayload.type = 'is_candidate'
          newPayload.value = payload.value.isCandidate
          break
        case 'follower':
          newPayload.type = 'is_follower'
          newPayload.value = payload.value.isFollowing
          break
        case 'winner':
          newPayload.type = 'is_winner'
          newPayload.value = payload.value.isWinner
          break
        case 'responder':
          newPayload.type = 'is_responder'
          newPayload.value = payload.value.isResponder
          break
        case 'winnerContact':
          newPayload.type = 'is_winner_contact'
          newPayload.value = payload.value.isWinnerContact
          break
      }
      this.$emit('change_flag', newPayload)
    },

    onPaging(payload: { pagingNo: number; limitCount?: number }) {
      this.$emit('paging', payload)

      this.fetchApplicants()
    },

    /**
     * NGアカウント追加/解除
     */
    changeNg(payload: { screenName: string; isNg: boolean; ngApplicantId: number | null }) {
      this.$emit('change_ng', payload)
    }
  }
})
</script>
